import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import toast from 'react-hot-toast';

export const useCreateJob = () => {
    const queryClient = useQueryClient();

    const { data: surveyors = [], isLoading: loadingSurveyors } = useQuery({
        queryKey: ['companySurveyors'],
        queryFn: () => api.get('/company/surveyors').then(res => res.data.data || []),
    });

    const { data: quotes = [], isLoading: loadingQuotes } = useQuery({
        queryKey: ['companyQuotes'],
        queryFn: () => api.get('/company/quotes').then(res => res.data.data || []),
    });

    const createJobMutation = useMutation({
        mutationFn: (data) => api.post('/company/jobs', data),
        onSuccess: () => {
            toast.success('Job created successfully!');
            queryClient.invalidateQueries(['companyJobs']);
            queryClient.invalidateQueries(['calendarJobs']);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || 'Failed to create job');
        },
    });

    return {
        surveyors,
        quotes,
        loadingSurveyors,
        loadingQuotes,
        createJob: createJobMutation.mutate,
        isCreating: createJobMutation.isPending,
    };
};